import apiClient from '@/plugins/axios';

export default {
	getMapItems(searchParam) {
		var query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';
		query += searchParam.mapId ? `&MapId=${searchParam.mapId}` : '';

		return apiClient.get(`v1/MapItem${query}`);
	},

	getMapItem(mapItemId) {
		return apiClient.get(`v1/MapItem/${mapItemId}`);
	},

	createMapItem(mapItem) {
		return apiClient.post('v1/MapItem', mapItem);
	},

	updateMapItem(mapItem) {
		var mapItemId = mapItem.id;

		return apiClient.put(`v1/MapItem/${mapItemId}`, mapItem);
	},

	deleteMapItem(mapItemId) {
		return apiClient.delete(`v1/MapItem/${mapItemId}`);
	}
};
